import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IExpedition, IExpeditionAutoControl } from "@/models";
import { TakePictures } from "@/components";
import { ToastHelper } from "@/helpers/ToastHelper";

@Component({
    name: "ExpeditionCardAutoControl",
    components: {
        "take-pictures": TakePictures,
    },
})

export default class ExpeditionCardAutoControl extends Vue {
    public isTakingPictures: boolean = false;

    constructor() {
        super();
    }

    public created(): void {
        this.$parent.$data.title = `Autocontrôle Quai ${this.expedition.dock} - ${this.expedition.transporter.name}`;
    }

    public get expedition(): IExpedition {
        return this.$store.getters["expeditions/getSelectedExpedition"]();
    }

    public get expeditionAutoControl(): IExpeditionAutoControl {
        return { ...this.$store.getters["expeditions/getExpeditionAutoControl"]() };
    }

    public get pictures(): string[] {
        return this.$store.getters["expeditions/getAutoControlPictures"]();
    }

    public previous(): void {
        this.refreshExpeditionAutoControl();
        this.$parent.$data.step--;
    }

    public next(): void {
        this.refreshExpeditionAutoControl();
        this.$parent.$data.step++;
    }

    public openPhotos(): void {
        navigator.mediaDevices.enumerateDevices().then(data => {
            if (data.some(x => x.kind === "videoinput")) {
                this.isTakingPictures = !this.isTakingPictures;
            } else {
                ToastHelper.general.noCamera();
            }
        });
    }

    private refreshExpeditionAutoControl(): void {
        this.$store.dispatch("expeditions/setExpeditionAutoControl", this.expeditionAutoControl);
    }
}
